
export default {
  props: {
    cover: String,
    video: String,
    type: String, // 目前支持两个值，preview: 针对模板预览，list: 针对列表item
    videoStyle: Object
  },
  data: function data() {
    return {
      hoverStatus: false,
      showVideo: false,
      loadVideo: false
    };
  },

  computed: {
    coverStyle: function coverStyle() {
      return {
        backgroundImage: 'url(' + this.cover + ')'
      };
    },
    playerClass: function playerClass() {
      if (this.type === 'list') {
        return 'video-player item';
      } else if (this.type === 'preview') {
        return 'video-player preview';
      }
      return 'video-player';
    },
    iconClass: function iconClass() {
      if (this.showVideo) {
        return 'player-icon hide';
      }
      return 'player-icon';
    }
  },
  methods: {
    focusPlayer: function focusPlayer() {
      var _this = this;

      if (this.type === 'list') {
        this.hoverStatus = true;
        // 时延一秒，如果还处于获取焦点的状态，再showPlayer
        setTimeout(function () {
          if (_this.hoverStatus) {
            _this.showPlayer();
          }
        }, 500);
      }
    },
    blurPlayer: function blurPlayer() {
      if (this.type === 'list') {
        this.hoverStatus = false;
        this.showVideo = false;
        this.loadVideo = false;
      }
    },
    previewVideo: function previewVideo() {
      if (this.type === 'preview') {
        this.showPlayer();
      }
    },
    showPlayer: function showPlayer() {
      var _this2 = this;

      this.showVideo = true;
      this.$nextTick(function () {
        _this2.addVideoListener();
      });
    },
    abortPreview: function abortPreview() {
      this.loadVideo = false;
      this.showVideo = false;
    },
    addVideoListener: function addVideoListener() {
      var _this3 = this;

      if (!this.$refs.playerVideo) return;
      this.$refs.playerVideo.addEventListener('canplay', function () {
        if (_this3.type === 'list' && _this3.blurPlayer && _this3.showVideo) {
          _this3.loadVideo = true;
        }
        if (_this3.type === 'preview' && _this3.showVideo) {
          _this3.loadVideo = true;
        }
      });
      this.$refs.playerVideo.addEventListener('ended', function () {
        if (_this3.type === 'list' && _this3.blurPlayer || _this3.type === 'preview') {
          _this3.abortPreview();
        }
      });
    }
  },
  mounted: function mounted() {}
};